import SvgIcon from "./SvgIcon";

export default function TriathlonIcon({
  width = "24",
  height = "24",
  color = "#000"
}) {
  return (
    <SvgIcon width={width} height={height}>
      <path
        d="M16.188 14.413c.176.104.377.158.582.157a1.138 1.138 0 0 0 .99-.61l.65-1.22a.317.317 0 0 1 .28-.17h2.48v-1.35h-2.48a1.671 1.671 0 0 0-1.45.89l-.44.83-1.66-3.11a1.147 1.147 0 0 0-1.579-.426c-.176.102-.32.25-.421.426l-.65 1.22a.32.32 0 0 1-.29.17h-2v1.37h2a1.681 1.681 0 0 0 1.48-.88l.44-.84 1.65 3.11c.097.18.242.33.418.433z"
        fill={color}/>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.38 20.22a8.25 8.25 0 1 1 .964-16.443c.287.033.573.081.856.143l-.011.048a8.273 8.273 0 0 1 2.384-.163c.358.028.714.08 1.066.156l.222-.052.145-.03a8.251 8.251 0 0 1 9.864 8.091 8.259 8.259 0 0 1-10.039 8.054l.009.036a8.254 8.254 0 0 1-3.86-.016 8.238 8.238 0 0 1-1.6.176zM6.106 6.196c.41-.41.858-.77 1.336-1.082a6.904 6.904 0 0 0-5.625 4.702 6.898 6.898 0 0 0 5.319 8.921 8.25 8.25 0 0 1-1.03-12.54zm5.011 12.687l-.074-.049a8.25 8.25 0 0 1-.148-13.627 6.896 6.896 0 0 0-4.883 3.261 6.899 6.899 0 0 0 5.105 10.415zm.68-12.65a6.898 6.898 0 0 1 3.832-1.163v.02a6.908 6.908 0 0 1 6.9 6.88 6.9 6.9 0 1 1-10.733-5.737z"
        fill={color}/>
    </SvgIcon>
  )
}
